import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
// import 'survey-core/defaultV2.min.css'
import { useMediaQuery } from 'react-responsive'
import { nouislider } from 'surveyjs-widgets'
import * as SurveyCore from 'survey-core'
import 'survey-core/i18n/traditional-chinese'
// import { settings } from 'survey-core'
import { templateJson } from '../home/json/templateJson.js'
nouislider(SurveyCore)
SurveyCore.surveyLocalization.locales['zh-tw'].clearCaption = '清除'
// SurveyJS 內建 chooseButtonCaption 只用 @property decorator 定義，沒在 Serializer.addClass("file") 註冊，
// 從 JSON 帶值會被靜默丟掉。這裡補上註冊讓 JSON 可以直接設按鈕文字。
SurveyCore.Serializer.addProperty('file', {
  name: 'chooseButtonCaption:text',
  serializationProperty: 'locChooseButtonCaption',
})

export function useConvertSurvey({
  survey,
  pid,
  setAc,
  setTk,
  ac,
  tk,
  setMyAgreeJson,
  imagesReadingTime,
  setImagesReadingTime,
  setIsLoading,
  completedHtml,
  visibleIfConditionsInit,
  notRequired,
  requiresLogin,
  mappedRateChoice,
  pageBreakQuestions,
  triggersConditionsInit,
  serial_num,
  // testJSON,
  bringOptionsMapRef,
  haUserId,
  haAccessToken,
  haMemberMissionId,
  setIsDkabio,
  userIdRef, // 暫存需加
  choiceIndexMapRef,
  questionMappings = {},
  sfdSamplerId,
  sfdPId,
  setWebAuthType: setWebAuthTypeExternal,
  transformSurveyData,
  forceHiddenQuestions,
}) {
  // 測試用開關：設為 true 會把所有題目放在同一頁，方便一次填完
  const DISABLE_PAGE_BREAK = false
  // 測試用開關：設為 true 會把所有題目都設為非必填，方便快速跳填
  const DISABLE_REQUIRED = false

  const host = process.env.REACT_APP_HOST
  // 取得問卷資訊
  const GetProjectInfo = '/clientWeb/v1/GetProjectInfo'
  // 登入驗證
  const UserWebAuthorize = '/clientWeb/v1/UserWebAuthorize'
  const UserWebAuthorizeV2 = '/clientWeb/v2/UserWebAuthorize'
  // 使⽤者加入問卷
  const JoinChat = '/clientWeb/v1/JoinChat'
  // 使⽤者取得問卷
  const GetQuestions = '/clientWeb/v1/GetQuestions'
  // other 跟 none 請搜尋 othernone順序
  // ============== othernone順序 ==============
  // settings.specialChoicesOrder.otherItem = [1]
  // settings.specialChoicesOrder.noneItem = [2]
  // ⬆⬆⬆⬆⬆⬆⬆⬆ othernone順序 ⬆⬆⬆⬆⬆⬆⬆⬆

  // ================ computex 2024 ================
  function computexLogo(pid) {
    if (pid === 'P240430105824' || pid === 'P240430105853') {
      return 'https://i.postimg.cc/D05qPdfm/banner-4x.png'
    } else if (pid === 'P250423112413307' || pid === 'P250424001910598') {
      // computex 2025
      return 'https://i.postimg.cc/9fLpw8NP/AI-wow-2025.jpg'
    } else if (pid === 'P240614183901' || pid === 'P240719175039533') {
      // DKABio-Light
      return 'https://i.postimg.cc/MH55knmD/DKABio-Light-LOGO.png'
    } else if (pid === 'P240703185556' || pid === 'P240827173131128') {
      // DKABio
      return 'https://i.postimg.cc/XYMPRVJD/DKABio-LOGO.png'
    } else {
      return ''
    }
  }
  function computexLang(pid, englishVersion, origin) {
    if (pid === 'P240430105853') {
      return englishVersion
    } else {
      return origin
    }
  }

  // discord
  async function sendDiscordNotification(message) {
    try {
      await axios.post('/api/send-notification', {
        content: message,
      })
    } catch (error) {
      console.error('Failed', error)
    }
  }
  const navigate = useNavigate()

  const isMobile = useMediaQuery({ query: '(max-width: 576px)' })

  const [userId, setuserId] = useState(null)
  const [sfdUserId, setSfdUserId] = useState(null)
  const [receivedSurvey, setReceivedSurvey] = useState(null)
  const [newSurvey, setNewSurvey] = useState(null)
  const [surveyTitle, setSurveyTitle] = useState('EZChoice')
  const [isFull, setisFull] = useState(false)
  const [webAuthType, setWebAuthType] = useState(0)
  const webAuthTypeRef = useRef(0)
  const webPass2Ref = useRef('')
  const webPass1AlertRef = useRef('')
  const webPass2AlertRef = useRef('')
  const pTypeRef = useRef(0)
  const projectPassRef = useRef('')
  const projectPassAlertRef = useRef('')
  const pageOrderRef = useRef(1)
  // 登入頁每按一次送出就 +1：通行碼填一樣的值時 sfdUserId/userId 不會變，
  // 少了這個計數器驗證 API 不會重打（活動式通行碼固定送 '' 更是永遠不變）
  const [authAttempt, setAuthAttempt] = useState(0)
  // 每次 UserWebAuthorize 成功就 +1：後端回同一組 ac/tk 時 JoinChat 也要重打
  const [authorizedAt, setAuthorizedAt] = useState(0)

  // 通行碼驗證失敗後把登入頁拉回可輸入狀態。
  // 登入用的 agree survey 送出後就是 completed，畫面會停在 completedHtml（問卷準備中…），
  // 換一個新的 json 物件才會重建 Model 回到 running。
  const resetAgreeSurvey = () => {
    setMyAgreeJson((prev) => (prev ? { ...prev } : prev))
  }

  // 暫存需加：當 userId 變更時，更新 ref
  useEffect(() => {
    if (userIdRef) {
      // userIdRef.current = userId
      console.log('userIdRef.current', userIdRef.current)
    }
  }, [userId, userIdRef])

  // GetProjectInfo 問卷有沒有滿
  useEffect(() => {
    setIsLoading(true)
    axios
      .post(
        host + GetProjectInfo,
        { pid: pid, ...(serial_num && { serial_num: serial_num }) },
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            Accept: '*/*',
          },
          timeout: 30000,
        }
      )
      .then((res) => {
        setSurveyTitle(res.data.name)
        if (res.data.code === '03049') {
          navigate(`/${pid}/notFound`)
        } else if (res.data.is_full) {
          setisFull(true)
          setMyAgreeJson({
            ...templateJson,
            logo: computexLogo(pid),
            locale: computexLang(pid, 'en', 'zh-tw'),
            pageNextText: computexLang(pid, 'next', '下一頁'),
            pagePrevText: computexLang(pid, 'prev', '上一頁'),
            completeText: computexLang(pid, 'complete', '完成'),
            title: res.data.name,
            completedHtml: `<h3>感謝您的參與</h3><h4 style='margin-top:50px'>手機下載 EZChoice</h4><h6 style='margin:20px'><a href='https://apps.apple.com/tw/app/ezchoice-%E6%98%93%E6%8F%AA%E7%B6%B2/id1458573198'>Apple Store 下載連結</a></h6><h6 style='margin:20px'><a href='https://play.google.com/store/apps/details?id=com.dataa.newezchoice'>Google Play 商店下載連結</a></h6><h4 style='margin-top:50px'>填寫其他問卷</h4><h5><a href=${window.location.origin}>回到首頁</a></h5>更多即時好康資訊！<br />立即加入EZChoice Line@好友</h4><h5><a href='https://lin.ee/HWETcqy'>EZChoice LINE@</a></h5>`,

            pages: [
              {
                name: 'page0',
                elements: [
                  {
                    type: 'panel',
                    elements: [
                      {
                        type: 'html',
                        name: 'intro',
                        html: "<h2 class='intro__heading title'>已達本問卷作答人數限制</h2>",
                      },
                    ],
                  },
                ],
              },
            ],
          })
        } else {
          if (res.data.enable_sfd === 1 && !sfdSamplerId) {
            navigate(`/${pid}/missingParams`)
            return
          }
          if (setIsDkabio && res.data.creator === 'CAeIG98z5') {
            setIsDkabio(true)
          }
          const webAuth = res.data.web_auth_type || 0
          const pType = res.data.p_type || 0
          setWebAuthType(webAuth)
          webAuthTypeRef.current = webAuth
          if (typeof setWebAuthTypeExternal === 'function') {
            setWebAuthTypeExternal(webAuth)
          }
          pTypeRef.current = pType
          webPass1AlertRef.current = res.data.pass_invalid_notice || ''
          webPass2AlertRef.current = res.data.pass_2nd_invalid_notice || ''
          projectPassAlertRef.current =
            res.data.pass_project_invalid_notice || ''

          setMyAgreeJson({
            ...templateJson,
            logo: computexLogo(pid),
            locale: computexLang(pid),
            title: res.data.name,
            completedHtml: `<h4>問卷準備中...</h4><h4>由於網路連線不穩定，可能會導致填寫過程中出現延遲。</h4><h4>建議您檢查網路連線狀況，並稍後重新整理頁面，或回到原頁面重新點擊連結再試一次。感謝您的耐心等待。</h4>`,
            completeText:
              res.data.creator === 'CAeIG98z5'
                ? '開始'
                : computexLang(pid, 'start', '進入問卷'),
            pageNextText: computexLang(pid, 'next', '下一頁'),
            pagePrevText: computexLang(pid, 'prev', '上一頁'),

            // completedBeforeHtml: '<h3>您已填過此問卷</h3>',
            pages: [
              {
                name: 'page0',
                elements: [
                  {
                    type: 'panel',
                    elements: [
                      {
                        type: 'html',
                        name: 'intro',
                        html: res.data.description,
                      },
                    ],
                  },
                  requiresLogin.login
                    ? ((haUserId && haAccessToken && haMemberMissionId) ||
                        userIdRef) &&
                      !requiresLogin.useUserIdLogin
                      ? {
                          // 不存在的題目
                          type: 'panel',
                          elements: [
                            {
                              type: 'radiogroup',
                              name: 'q0',
                              title: '你同意嗎',
                              isRequired: true,
                              hideNumber: true,
                              requiredErrorText: `${requiresLogin.title}不可空白`,
                              choices: ['我同意'],
                              visible: false,
                            },
                          ],
                          name: 'panel1',
                        }
                      : {
                          type: 'panel',
                          elements: [
                            {
                              type: 'text',
                              name: 'login',
                              title: `請輸入${requiresLogin.title}`,
                              isRequired: true,
                              hideNumber: true,
                              requiredErrorText: `${requiresLogin.title}不可空白`,
                              placeholder: requiresLogin.placeholder,
                            },
                          ],
                          name: 'panel1',
                        }
                    : '',
                  // 名單式調查通行碼（web_auth_type）：有 sfd_sampler_id 時直接帶入，不需手動輸入
                  webAuth > 0 && !sfdSamplerId
                    ? {
                        type: 'panel',
                        name: 'panelWebAuth',
                        elements: [
                          {
                            type: 'text',
                            name: 'pass1',
                            title: res.data.pass_dialog_word,
                            placeholder: res.data.pass_dialog_example,
                            isRequired: true,
                            hideNumber: true,
                            requiredErrorText: '通行碼不可空白',
                          },
                          ...(webAuth === 2
                            ? [
                                {
                                  type: 'text',
                                  name: 'pass2',
                                  title: res.data.pass_2nd_dialog_word,
                                  placeholder: res.data.pass_2nd_dialog_example,
                                  isRequired: true,
                                  hideNumber: true,
                                  requiredErrorText: '通行碼不可空白',
                                },
                              ]
                            : []),
                        ],
                      }
                    : '',
                  // 活動式通行碼（p_type=1）：一定是手動輸入模式
                  pType === 1
                    ? {
                        type: 'panel',
                        name: 'panelPType',
                        elements: [
                          {
                            type: 'text',
                            name: 'project_pass',
                            title: res.data.pass_project_dialog_word,
                            placeholder: res.data.pass_project_dialog_example,
                            isRequired: true,
                            hideNumber: true,
                            requiredErrorText: '通行碼不可空白',
                          },
                        ],
                      }
                    : '',
                ],
              },
            ],
          })
        }
      })
      .catch((e) => {
        console.log('e', e)

        // 檢查是否為 timeout 錯誤
        const isTimeout =
          e.code === 'ECONNABORTED' ||
          e.message.includes('timeout') ||
          e.message.includes('Network Error') ||
          !e.response // 沒有回應通常也是網路問題

        if (isTimeout) {
          alert('網路連線逾時，請重新整理頁面後再試一次')
          return
        }

        // 檢查是否有 response 存在
        if (e.response && e.response.data && e.response.data.code) {
          const errorCode = e.response.data.code

          if (errorCode === '04008') {
            // 04008 不需要打 Discord，直接導航
            navigate(`/${pid}/notFound`)
          } else {
            // 非 04008 的情況：先 alert，再打 Discord
            alert('發生錯誤，請重新整理頁面後再試一次')
            sendDiscordNotification(
              `EZC Web GetProjectInfo Error \n Error: ${e} \n pid: ${pid} \n ac: ${ac} \n tk: ${tk} \n Response: ${e.response?.data?.msg} \n Response Code: ${e.response?.data?.code}`
            )
          }
        } else {
          // 沒有 response 的情況（可能是網路錯誤等）
          alert('網路連線異常，請重新整理頁面後再試一次')
          sendDiscordNotification(
            `EZC Web GetProjectInfo Error \n Error: ${e} \n pid: ${pid} \n ac: ${ac} \n tk: ${tk} \n Response: 無回應資料`
          )
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  // 登入驗證
  useEffect(() => {
    if (!isFull) {
      survey.onComplete.add((sender, options) => {
        let surveyData = sender.data
        // 讓每一次送出都算一次新的驗證，避免重填同樣的通行碼時 state 沒變、API 不重打
        setAuthAttempt((n) => n + 1)
        if (requiresLogin.login) {
          if (!requiresLogin.useUserIdLogin) {
            if (haUserId) {
              setuserId(haUserId)
            }
            if (userIdRef) {
              console.log('userIdRef', userIdRef.current)
              setuserId(userIdRef.current)
            }
          } else {
            userIdRef.current = surveyData.login
            setuserId(surveyData.login)
          }
        } else {
          if (sfdSamplerId) {
            // 活動式通行碼一定是手動輸入
            if (pTypeRef.current === 1 && surveyData.project_pass) {
              projectPassRef.current = surveyData.project_pass
            }
            setSfdUserId(sfdSamplerId)
          } else if (webAuthTypeRef.current > 0) {
            // 名單式調查：走 UserWebAuthorizeV2
            if (webAuthTypeRef.current === 2 && surveyData.pass2) {
              webPass2Ref.current = surveyData.pass2
            }
            // 若同時有活動式通行碼，一併存入 ref（JoinChat 時帶入）
            if (pTypeRef.current === 1 && surveyData.project_pass) {
              projectPassRef.current = surveyData.project_pass
            }
            setSfdUserId(surveyData.pass1)
          } else if (pTypeRef.current === 1) {
            // 只有活動式通行碼：走 V2，account/pass 留空
            projectPassRef.current = surveyData.project_pass || ''
            setSfdUserId('')
          } else {
            setuserId(true)
          }
        }
      })
    }
  }, [survey])

  const authRequestBody = requiresLogin.login
    ? requiresLogin.needUserId
      ? // EZC會員ID
        { account: userId, type: 2 }
      : // 有通⾏碼
        { account: userId, type: 0 }
    : // 非EZC會員
      { type: 1 }

  // 登入
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await axios.post(
          host + UserWebAuthorize,
          authRequestBody,
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              ai: 'EZC-Web',
            },
            timeout: 30000,
          }
        )
        setIsLoading(false)

        if (response.data.code === '02040') {
          setAc(response.headers.ac)
          setTk(response.headers.tk)
          setAuthorizedAt((n) => n + 1)
        } else {
          alert(
            requiresLogin.login
              ? requiresLogin.alert
              : '伺服器忙碌中，請稍後再試，謝謝！'
          )
          window.location.reload()
        }
      } catch (e) {
        setIsLoading(false)
        console.log(e)
        // 檢查是否為網路錯誤或 timeout
        const isNetworkError =
          e.code === 'ECONNABORTED' || // axios timeout
          e.message.includes('timeout') || // 一般 timeout 訊息
          e.message.includes('Network Error') || // 網路錯誤
          !e.response // 沒有伺服器回應

        if (isNetworkError) {
          alert('網路連線異常或逾時，請檢查網路狀況後重新整理頁面')
          return
        }

        // 有正常 API 回應的錯誤
        if (e.response && e.response.data) {
          alert(
            requiresLogin.login
              ? requiresLogin.alert
              : '伺服器忙碌中，請重新整理頁面後再試一次'
          )
        } else {
          // 其他未知錯誤
          alert('發生未知錯誤，請重新整理頁面後再試一次')
        }
        sendDiscordNotification(
          `EZC Web UserWebAuthorize Error \n Error: ${e}  \n pid: ${pid} \n ac: ${ac} \n tk: ${tk} \n Response: ${e.response?.data?.msg} \n Response Code: ${e.response?.data?.code}`
        )
      }
    }
    if (userId) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, authAttempt])

  // sfd_sampler_id 登入 v2
  useEffect(() => {
    if (sfdUserId === null) return
    const fetchDataV2 = async () => {
      setIsLoading(true)
      try {
        const response = await axios.post(
          host + UserWebAuthorizeV2,
          { pid: pid, account: sfdUserId, pass: webPass2Ref.current },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              ai: 'EZC-Web-v2',
            },
            timeout: 30000,
          }
        )
        setIsLoading(false)
        if (response.data.code === '02040') {
          setAc(response.headers.ac)
          setTk(response.headers.tk)
          setAuthorizedAt((n) => n + 1)
        } else if (response.data.code === '04008') {
          // 此帳號不存在
          alert(webPass1AlertRef.current)
          resetAgreeSurvey()
        } else if (response.data.code === '04006') {
          // 密碼輸入錯誤
          alert(webPass2AlertRef.current)
          resetAgreeSurvey()
        } else if (response.data.code === '03049') {
          // 用戶不在名單內
          alert(response.data.msg)
          resetAgreeSurvey()
        } else {
          alert(
            webAuthTypeRef.current > 0
              ? webPass1AlertRef.current
              : '伺服器忙碌中，請稍後再試，謝謝！'
          )
          window.location.reload()
        }
      } catch (e) {
        setIsLoading(false)
        const isNetworkError =
          e.code === 'ECONNABORTED' ||
          e.message.includes('timeout') ||
          e.message.includes('Network Error') ||
          !e.response
        if (isNetworkError) {
          alert('網路連線異常或逾時，請檢查網路狀況後重新整理頁面')
          return
        }
        if (e.response && e.response.data) {
          alert(
            webAuthTypeRef.current > 0
              ? webPass1AlertRef.current
              : '伺服器忙碌中，請重新整理頁面後再試一次'
          )
        } else {
          alert('發生未知錯誤，請重新整理頁面後再試一次')
        }
        sendDiscordNotification(
          `EZC Web UserWebAuthorizeV2 Error \n Error: ${e} \n pid: ${pid} \n Response: ${e.response?.data?.msg} \n Response Code: ${e.response?.data?.code}`
        )
      }
    }
    fetchDataV2()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sfdUserId, authAttempt])

  //  加入問卷&拉問卷
  useEffect(() => {
    setIsLoading(true)
    const JoinChatPost = async () => {
      try {
        const response = await axios.post(
          host + JoinChat,
          {
            pid: pid,
            ...(serial_num && { serial_num: serial_num }),
            ...(sfdPId && { sfd_pid: sfdPId }),
            ...(projectPassRef.current && {
              project_pass: projectPassRef.current,
            }),
          },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              ac: ac,
              tk: tk,
            },
            timeout: 30000,
          }
        )
        //  填過的狀態
        if (response.data.code === '03044') {
          navigate(`/${pid}/done`)
        } else if (response.data.code === '03046') {
          navigate(`/${pid}/closed`)
        } else if (response.data.code === '03065') {
          navigate(`/${pid}/closed`)
        } else if (response.data.code === '03052') {
          navigate(`/${pid}/closed`)
        } else if (response.data.code === '03048') {
          // 通行碼錯誤
          alert(projectPassAlertRef.current)
          resetAgreeSurvey()
        } else if (response.data.code === '03049') {
          // 用戶不在名單內
          alert(response.data.msg)
          resetAgreeSurvey()
        } else if (response.data.code === '02000') {
          GetQuestionsPost()
        } else {
          navigate(`/${pid}/submitFail`)
        }
      } catch (e) {
        console.log(e)

        // 檢查是否為網路錯誤或 timeout
        const isNetworkError =
          e.code === 'ECONNABORTED' || // axios timeout
          e.message.includes('timeout') || // 一般 timeout 訊息
          e.message.includes('Network Error') || // 網路錯誤
          !e.response // 沒有伺服器回應

        if (isNetworkError) {
          alert('網路連線異常或逾時，請檢查網路狀況後重新整理頁面')
          return
        }

        // 有正常 API 回應的錯誤
        if (e.response && e.response.data && e.response.data.code) {
          const errorCode = e.response.data.code

          if (errorCode === '04006') {
            // Invalid access - 通常是 token 過期
            alert('存取權限已過期，請重新整理頁面後再試一次')
          } else {
            // 其他 API 錯誤
            alert('載入問卷內容時發生錯誤，請重新整理頁面後再試一次')
          }
        } else {
          // 其他未知錯誤
          alert('發生未知錯誤，請重新整理頁面後再試一次')
        }

        // 打 Discord 通知
        sendDiscordNotification(
          `EZC Web JoinChatPost Error \n Error: ${e} \n pid: ${pid} \n ac: ${ac} \n tk: ${tk} \n Response: ${e.response?.data?.msg} \n Response Code: ${e.response?.data?.code} \n Message: ${e.message}`
        )
      } finally {
        setIsLoading(false)
      }
    }

    const GetQuestionsPost = async () => {
      setIsLoading(true)
      try {
        const response = await axios.post(
          host + GetQuestions,
          { pid: pid },
          {
            headers: {
              'Content-Type': 'text/plain; charset=UTF-8',
              Accept: '*/*',
              ac: ac,
              tk: tk,
            },
            timeout: 30000,
          }
        )

        // console.log('GetQuestionsRes', response.data)
        const surveyData = response.data
        const finalSurveyData =
          typeof transformSurveyData === 'function'
            ? transformSurveyData(surveyData)
            : surveyData
        setReceivedSurvey(finalSurveyData)
        if (bringOptionsMapRef) {
          bringOptionsMapRef.current = {}
          Object.entries(questionMappings).forEach(([from, to]) => {
            bringOptionsMapRef.current[from] = to
          })
          console.log(
            '✅ bringOptionsMapRef（手動）已設定:',
            bringOptionsMapRef.current
          )
        }
      } catch (e) {
        console.log(e)

        // 檢查是否為網路錯誤或 timeout
        const isNetworkError =
          e.code === 'ECONNABORTED' || // axios timeout
          e.message.includes('timeout') || // 一般 timeout 訊息
          e.message.includes('Network Error') || // 網路錯誤
          !e.response // 沒有伺服器回應

        if (isNetworkError) {
          alert('網路連線異常或逾時，請檢查網路狀況後重新整理頁面')
          return
        }

        // 有正常 API 回應的錯誤
        if (e.response && e.response.data && e.response.data.code) {
          const errorCode = e.response.data.code

          if (errorCode === '04006') {
            // Invalid access - 通常是 token 過期
            alert('存取權限已過期，請重新整理頁面後再試一次')
          } else {
            // 其他 API 錯誤
            alert('載入問卷內容時發生錯誤，請重新整理頁面後再試一次')
          }
        } else {
          // 其他未知錯誤
          alert('發生未知錯誤，請重新整理頁面後再試一次')
        }

        sendDiscordNotification(
          `EZC Web GetQuestionsPost Error \n Error: ${e} \n pid: ${pid} \n ac: ${ac} \n tk: ${tk} \n Response: ${e.response?.data?.msg} \n Response Code: ${e.response?.data?.code} \n Message: ${e.message}`
        )
      } finally {
        setIsLoading(false)
      }
    }

    if (ac && tk) {
      JoinChatPost()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ac, tk, authorizedAt])

  let tempSurvey = {
    ...templateJson,
    title: surveyTitle,
    // completeText: '完成作答',
    startSurveyText: '下一頁',
    firstPageIsStarted: false,
    // showTimerPanel: 'top',
    // maxTimeToFinishPage: 10,
    // maxTimeToFinish: 25,
    showProgressBar: 'bottom',
    showPrevButton: true,
    widthMode: isMobile ? 'responsive' : 'static',
    width: isMobile ? '' : '800px',
    completedHtml:
      completedHtml ||
      `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>回到首頁</a>`,
    // TODO:
    // focusFirstQuestionAutomatic: true,
    triggers: [],
    pages: [{ name: 'page0', elements: [] }],
    // ============ computex 2024 ============
    logo: computexLogo(pid),
    locale: computexLang(pid, 'en', 'zh-tw'),
    completeText:
      pid === 'P241220112137853' //高敏感男性
        ? '下一頁'
        : computexLang(pid, 'complete', '完成作答'),
    pageNextText: computexLang(pid, 'next', '下一頁'),
    pagePrevText: computexLang(pid, 'prev', '上一頁'),
  }

  // showOtherItem
  function checkShowOtherItem(data) {
    for (let i = 0; i < data.op.length; i++) {
      if (data.op[i].o_type === 6) {
        return true
      }
    }

    return false
  }

  // otherText
  function checkOtherText(data) {
    // 遍歷op對象
    for (let i = 0; i < data.op.length; i++) {
      // 如果找到"o_type": 6
      if (data.op[i].o_type === 6) {
        return data.op[i].na
      }
    }

    return ''
  }

  // placeholder
  function checkPlaceholder(data) {
    if (data.cf.q_type === 4) {
      return data.op[0]?.na
    }

    return ''
  }

  // random 小工具
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      let j = Math.floor(Math.random() * (i + 1))
      ;[array[i], array[j]] = [array[j], array[i]]
    }
    return array
  }

  // choices
  function convertChoices(data) {
    // 這是好的
    const op = data.op || []
    const parameters = data.cf?.parameters || {}
    const groupIndex = parameters.group?.[0]
    const isRand = parameters.random?.is_rand === 1
    const randGroups = parameters.random?.rand || []

    // 過濾掉 group 中的 none 選項
    let filteredChoices = op
    if (typeof groupIndex === 'number' && op[0]?.o_type !== 1) {
      filteredChoices = op.filter((_, i) => i !== groupIndex)
    }

    // 加入原始索引
    const baseChoices = filteredChoices
      .map((v, i) => ({ ...v, originalIndex: i }))
      .filter((v) => v.o_type === 0 || v.o_type === 1)

    // 預先轉換 mappedChoices 並用 Map 加快查找
    const mappedChoices = baseChoices.map((v) => ({
      value: v.originalIndex,
      text: v.na,
      imageLink: v.o_type === 1 ? v.lnk : '',
    }))
    const mappedChoiceMap = new Map(mappedChoices.map((c) => [c.value, c]))

    if (isRand && Array.isArray(randGroups)) {
      const usedIndices = new Set(randGroups.flat())

      // 隨機每一組 group 內部順序
      const shuffledGroups = randGroups.map((group) => {
        const groupItems = group
          .map((idx) => mappedChoiceMap.get(idx))
          .filter(Boolean)
        for (let i = groupItems.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1))
          ;[groupItems[i], groupItems[j]] = [groupItems[j], groupItems[i]]
        }
        return { indices: group, items: groupItems }
      })

      // 將所有項目根據原本位置還原
      const finalOrdered = []

      for (let i = 0; i < op.length; i++) {
        if (usedIndices.has(i)) {
          const group = shuffledGroups.find((g) => g.indices.includes(i))
          const item = group?.items.shift()
          if (item) {
            finalOrdered.push(item)
          }
        } else {
          const fixedItem = mappedChoiceMap.get(i)
          if (fixedItem) {
            finalOrdered.push(fixedItem)
          }
        }
      }

      return finalOrdered
    }

    return mappedChoices
  }

  function convertDropdownChoices(data) {
    let mapedChoices = data.op.map((v, i) => {
      return {
        value: i,
        text: v.na,
      }
    })

    return mapedChoices
  }

  // 非必填
  function checkNotRequired(questionIndex) {
    // TODO: 上是對的
    let returnValue = true
    // let returnValue = false
    if (notRequired) {
      notRequired.forEach((i) => {
        // Consider float matching for entire question?
        // Usually `117` in notRequired means `117` exact.
        // But `117.0` === `117`.
        if (questionIndex === i) {
          returnValue = false
          // returnValue = true
        }
      })
    }

    return returnValue
  }

  // showNoneItem
  function checkShowNoneItem(data) {
    if (data.cf.parameters.group) {
      if (data.cf.parameters.group.length > 0) {
        return true
      }
    }
    return false
  }

  // showNoneItem
  function checkNoneText(data) {
    if (data.cf.parameters.group) {
      if (data.cf.parameters.group.length > 0) {
        return data.op[data.cf.parameters.group[0]].na
      }
    }

    return ''
  }

  // multipleImages
  function multipleImages(data) {
    let img = ''
    for (let i = 0; i < data.ma.images.length; i++) {
      img += `<img src=${data.ma.images[i]} alt="image" />`
    }

    return `<div class="imgWrap50"><h2 style="text-align: center">請仔細觀看再進入下一頁</h2>${img}<h2 class="thirtySecondDelete" style="text-align: center">請完整觀看內容，稍後即可繼續作答</h2></div>`
  }

  // 矩陣欄選項
  function convertMatrixColumns(data) {
    let mapedChoices = data.cf.parameters.row_op.map((v, i) => {
      return {
        value: i,
        text: v,
      }
    })

    return mapedChoices
  }

  // 矩陣列選項
  function convertMatrixRows(data, currentQid, visibleIfConditionsInit) {
    const isRand = data.cf?.parameters?.random?.is_rand === 1
    const randGroups = data.cf?.parameters?.random?.rand || []

    const rows = data.op.map((v, i) => {
      const rowKey = `q${currentQid}.row${i}`
      return {
        value: i,
        text: v.na,
        ...(visibleIfConditionsInit?.[rowKey]
          ? { visibleIf: visibleIfConditionsInit[rowKey] }
          : {}),
      }
    })

    if (isRand && Array.isArray(randGroups) && randGroups.length > 0) {
      const usedIndices = new Set(randGroups.flat())

      // 隨機每一組 group 內部順序
      const shuffledGroups = randGroups.map((group) => {
        const groupItems = group.map((idx) => rows[idx]).filter(Boolean)
        for (let i = groupItems.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1))
          ;[groupItems[i], groupItems[j]] = [groupItems[j], groupItems[i]]
        }
        return { indices: group, items: groupItems }
      })

      // 將所有項目根據原本位置還原
      const finalOrdered = []

      for (let i = 0; i < data.op.length; i++) {
        if (usedIndices.has(i)) {
          const group = shuffledGroups.find((g) => g.indices.includes(i))
          const item = group?.items.shift()
          if (item) {
            finalOrdered.push(item)
          }
        } else {
          const fixedItem = rows[i]
          if (fixedItem) {
            finalOrdered.push(fixedItem)
          }
        }
      }

      return finalOrdered.filter(Boolean)
    }

    return rows
  }

  // imagesReadingTime 閱讀時間每題不一樣
  function getImageReadingTime(data, globalReadingTime) {
    // 1. 優先檢查題目自身的設定
    if (
      data.cf.parameters &&
      typeof data.cf.parameters.imageReadingTime === 'number'
    ) {
      return data.cf.parameters.imageReadingTime
    }

    // 2. 檢查媒體內容的特定設定
    if (data.ma.readingTime !== undefined) {
      return data.ma.readingTime
    }

    // 3. 如果沒有媒體內容，返回 0
    const hasMedia = data.ma.image || data.ma.images.length > 0 || data.ma.video
    if (!hasMedia) {
      return 0
    }

    // 4. 最後使用全局設定
    return globalReadingTime
  }

  // 跳題邏輯函數
  // ===== 開關：要不要印偵錯訊息 =====
  const ROUTING_DEBUG = false

  function logDebug(...args) {
    if (ROUTING_DEBUG) console.log('[routing]', ...args)
  }

  // 單選(=) / 複選(anyof) 條件字串
  function buildChoiceCondition(qName, isMulti, indices) {
    if (!Array.isArray(indices)) indices = [indices]
    return isMulti
      ? `{${qName}} anyof [${indices.join(', ')}]`
      : indices.map((i) => `{${qName}} = ${i}`).join(' or ')
  }

  // 是否為「不需跳題」：
  // 1) ty !== 1（例如 ty:0）→ 不需跳題
  // 2) 沒有 ta 或 ta 為空 → 不需跳題
  // 3) ta 全部等於「當前題下一題」(1-based)
  function isNoJumpRoute(currentIndex0, ty, ta) {
    // 0) ty:0 直接不跳
    if (ty !== 1 && ty !== 2) return true

    // 1) 無 ta / 空 ta 也不跳
    if (!Array.isArray(ta) || ta.length === 0) return true

    // 2) 全等於「下一題」(1-based)
    const nextOneBased = currentIndex0 + 2 // 0-based +1(自身) +1(下一題)
    const allNext = ta.every((t) => t !== 999 && t === nextOneBased)
    if (allNext) return true

    // 其餘：需要跳題
    return false
  }

  // 統計每一題(目標題)的「前驅題集合」(in-degree，以集合表示唯一來源數)
  // 注意：不需跳題也要算入 in-degree（因為它確實把路徑導向該目標）
  function computeConvergeTargets(surveyData) {
    const incoming = new Map() // key: targetIdx(0-based)，val: Set of sourceIdx

    const addEdge = (fromIdx0, toIdx0) => {
      if (toIdx0 < 0 || toIdx0 >= surveyData.data.length) return
      if (!incoming.has(toIdx0)) incoming.set(toIdx0, new Set())
      incoming.get(toIdx0).add(fromIdx0)
    }

    surveyData.data.forEach((q, i) => {
      const route = q?.ru?.route || {}
      const ty = route.ty
      const ta = route.ta

      if (isNoJumpRoute(i, ty, ta)) {
        // 預設順接：i -> i+1
        addEdge(i, i + 1)
        logDebug(`Q${i} NO-JUMP edge: q${i} -> q${i + 1}`)
        return
      }

      // 有路由：把所有非 999 的目標算進 in-degree
      ta.forEach((targetOneBased) => {
        if (targetOneBased === 999) return
        const targetIdx0 = targetOneBased - 1
        addEdge(i, targetIdx0)
        logDebug(`Q${i} JUMP edge: q${i} -> q${targetIdx0}`)
      })
    })

    // 匯聚點：有 2 個以上獨立前驅
    const converge = new Set(
      [...incoming.entries()]
        .filter(([, fromSet]) => fromSet.size >= 2)
        .map(([idx0]) => idx0)
    )

    if (ROUTING_DEBUG) {
      console.groupCollapsed('[routing] incoming (predecessors)')
      ;[...incoming.entries()].forEach(([k, v]) =>
        console.log(`q${k} <=`, [...v].map((x) => `q${x}`).join(', '))
      )
      console.groupEnd()

      console.log(
        '[routing] converge targets:',
        [...converge].map((i) => `q${i}`)
      )
    }

    return converge
  }

  // 只在「目標題」寫 visibleIf（不需跳題不建立 direct）
  // 若目標題是匯聚點 → 不建立 direct visibleIf（保持常顯）
  function buildDirectVisibleIf(surveyData, convergeTargets) {
    const visibleIfMap = {}
    const triggers = []

    surveyData.data.forEach((q, i) => {
      const route = q?.ru?.route || {}
      const ty = route.ty
      const ta = route.ta

      // 判斷複選題（你的資料中 q_type === 2 為複選）
      const isMulti = q?.cf?.q_type === 2
      const qName = `q${i}`

      if (isNoJumpRoute(i, ty, ta)) {
        logDebug(`Q${i} is NO-JUMP → skip direct visibleIf`)
        return
      }

      const non999 = (ta || []).filter((t) => t !== 999)

      non999.forEach((targetOneBased, choiceIndex0) => {
        const targetIdx0 = targetOneBased - 1
        const targetQName = `q${targetIdx0}`

        // 匯聚點：該題保持常顯 → 不寫 direct visibleIf
        if (convergeTargets.has(targetIdx0)) {
          logDebug(
            `Skip direct visibleIf for converge ${targetQName} (from q${i})`
          )
          return
        }

        const cond = buildChoiceCondition(qName, isMulti, choiceIndex0)
        if (visibleIfMap[targetQName]) {
          visibleIfMap[targetQName] += ` or (${cond})`
        } else {
          visibleIfMap[targetQName] = cond
        }
        logDebug(`Direct visibleIf add → ${targetQName}`, { from: qName, cond })
      })

      // 999 → complete 觸發
      ;(ta || []).forEach((t, choiceIndex0) => {
        if (t === 999) {
          const expr = buildChoiceCondition(qName, isMulti, choiceIndex0)
          triggers.push({ type: 'complete', expression: expr })
          logDebug(`Q${i} choice ${choiceIndex0} → COMPLETE`, { expr })
        }
      })
    })

    return { visibleIfMap, triggers }
  }

  // 將上一題的 guard 往後傳（接題保護），遇到「匯聚點」或「已有 direct visibleIf」就重置或覆寫
  function forwardPropagateVisibility(
    surveyData,
    visibleIfMap,
    convergeTargets
  ) {
    let guard = ''

    for (let j = 0; j < surveyData.data.length; j++) {
      const qName = `q${j}`

      // 匯聚點：保持常顯、清掉 guard
      if (convergeTargets.has(j)) {
        if (guard) logDebug(`Hit converge at ${qName}, clear guard`)
        guard = ''
        continue
      }

      if (visibleIfMap[qName]) {
        // 這題有 direct → 以這題為新的 guard（後續沿用）
        guard = visibleIfMap[qName]
        logDebug(`Direct guard set at ${qName}`, { guard })
      } else if (guard) {
        // 無 direct，但前方已有 guard → 繼承
        visibleIfMap[qName] = `(${guard})`
        logDebug(`Inherit guard → ${qName}`, { guard })
      }
    }

    return visibleIfMap
  }

  // ✅ 入口：由 route 參數自動產生 SurveyJS 的 visibleIf 與 complete 觸發
  function processRoutingLogic(surveyData) {
    logDebug('=== processRoutingLogic start ===')

    // 先用「所有邊」（包含不需跳題的順接）計算匯聚點
    const convergeTargets = computeConvergeTargets(surveyData)

    // 只針對「真正跳題」建立 direct visibleIf；匯聚點不設條件
    const { visibleIfMap, triggers } = buildDirectVisibleIf(
      surveyData,
      convergeTargets
    )

    // 將 guard 往後傳，保護接題型中繼段
    const finalVisibleIf = forwardPropagateVisibility(
      surveyData,
      visibleIfMap,
      convergeTargets
    )

    if (ROUTING_DEBUG) {
      console.groupCollapsed('[routing] Final visibleIf map')
      Object.entries(finalVisibleIf).forEach(([k, v]) => {
        console.log(k, '→', v)
      })
      console.groupEnd()

      console.groupCollapsed('[routing] Triggers')
      console.log(triggers)
      console.groupEnd()
    }

    logDebug('=== processRoutingLogic end ===')
    return {
      visibleIfConditions: finalVisibleIf,
      triggers,
    }
  }

  useEffect(() => {
    const convertedToNewSurvey = (receivedSurvey) => {
      if (receivedSurvey) {
        // TODO:post 回來的問卷
        // console.log('receivedSurvey', receivedSurvey)

        // 選項帶入帶出
        // 設定選項帶入映射
        // setupBringOptionsMapping(receivedSurvey, bringOptionsMapRef)
        // receivedSurvey.data.forEach((data, currentIndex) => {
        //   // 選項帶入帶出
        //   // {被帶入選項的題號: 要帶出選項的題號} {"q36": "q35"}

        //   if (data.ru?.op_bring?.b_type === 3) {
        //     // bringOptionsMapRef.current = {}
        //     if (bringOptionsMapRef) {
        //       const bringOptionsMap = {}
        //       const bringFrom = 'q' + (data.ru.op_bring.b_qid - 1)
        //       const bringTo = `q${currentIndex}`
        //       bringOptionsMap[bringFrom] = bringTo
        //       if (bringOptionsMapRef) {
        //         bringOptionsMapRef.current = bringOptionsMap
        //         console.log(
        //           '✅ bringOptionsMapRef 已設定:',
        //           bringOptionsMapRef.current
        //         )
        //       }
        //     }
        //     // choicesFromQuestions[
        //     //   `q${data.ru?.op_bring?.b_qid - 1}`
        //     // ] = `q${currentIndex}`
        //   }
        // })
        let visibleIfConditions = {}
        if (visibleIfConditionsInit !== null) {
          visibleIfConditions = visibleIfConditionsInit
        } else {
          const routingResult = processRoutingLogic(receivedSurvey)
          visibleIfConditions = routingResult.visibleIfConditions
          // triggers = routingResult.triggers
        }
        // 強制隱藏題目：不論上面走哪個分支（手動或 JSON route 自動產生），
        // 這裡都覆蓋上去。用途：問卷沿用共用題庫、部分題目已在別支問卷問過，要一律隱藏，
        // 但仍要保留這份 JSON 自己 ru.route 的自動跳題邏輯。
        if (forceHiddenQuestions) {
          visibleIfConditions = {
            ...visibleIfConditions,
            ...forceHiddenQuestions,
          }
        }
        // receivedSurvey.data.forEach((data, currentIndex) => {
        //   if (data.ru?.route?.ty && data.ru?.route?.ta) {
        //     let routeArray = data.ru.route.ta
        //     // TODO: other/none

        //     // 一開始就要知道會跳幾題
        //     function findDifference(array) {
        //       if (array.length === 0) return null // 處理空陣列
        //       let max = Math.max(...array)
        //       let min = Math.min(...array)
        //       if (max === 999) return 0
        //       return max - min
        //     }
        //     let questionsHasVisibleIf = 0
        //     let diff = findDifference(routeArray)
        //     questionsHasVisibleIf += diff

        //     // console.log('questionsHasVisibleIf', questionsHasVisibleIf)

        //     // [2,2,2,2,2,3,3,3,3,3]
        //     // [18, 21]
        //     // [21, 18]
        //     // [25, 25, 25, 25, 25, 25, 25, 24]
        //     // [5, 7, 5]

        //     // 單選跳題
        //     if (data.ru?.route?.ty === 1 || data.ru?.route?.ty === 2) {
        //       routeArray.forEach((targetIndex, choiceIndex) => {
        //         if (targetIndex - 1 === currentIndex + 1) {
        //           // 完成作答
        //           if (questionsHasVisibleIf === 0) {
        //             // console.log('結束作答', questionsHasVisibleIf)
        //           } else if (questionsHasVisibleIf > 0) {
        //             // 複選要移駕 visibleIfConditionsInit
        //             if (checkShowNoneItem(data)) {
        //               visibleIfConditions[
        //                 `q${targetIndex - 1}`
        //               ] = `{q${currentIndex}} = 'none'`
        //             } else if (
        //               // 跳很多題
        //               visibleIfConditions.hasOwnProperty(
        //                 `q${targetIndex - 1}`
        //               )
        //             ) {
        //               for (
        //                 let i = currentIndex + 1;
        //                 i <= currentIndex + Math.abs(questionsHasVisibleIf);
        //                 i++
        //               ) {
        //                 visibleIfConditions[
        //                   `q${i}`
        //                 ] += ` or {q${currentIndex}} = ${choiceIndex}`
        //               }
        //             } else {
        //               for (
        //                 let i = currentIndex + 1;
        //                 i <= currentIndex + Math.abs(questionsHasVisibleIf);
        //                 i++
        //               ) {
        //                 visibleIfConditions[
        //                   `q${i}`
        //                 ] = `{q${currentIndex}} = ${choiceIndex}`
        //               }
        //             }
        //           }
        //         }
        //       })
        //       // TODO: visibleIfConditions
        //       // console.log('visibleIfConditions', visibleIfConditions)
        //       // console.log(
        //       //   'transformToVisibilityRules',
        //       //   transformToVisibilityRules(data, currentIndex)
        //       // )
        //     }
        //     // if (data.ru?.route?.ty === 2) {
        //     //   routeArray.forEach((targetIndex, choiceIndex) => {
        //     //     if (targetIndex - 1 === currentIndex + 1) {
        //     //       if (questionsHasVisibleIf === 0) {
        //     //         // console.log('結束作答', questionsHasVisibleIf)
        //     //       } else if (questionsHasVisibleIf > 0) {
        //     //         if (checkShowNoneItem(data)) {
        //     //           // Ensure the array exists, then push 'none' condition
        //     //           visibleIfConditions[`q${targetIndex - 1}`] =
        //     //             visibleIfConditions[`q${targetIndex - 1}`] || []
        //     //           visibleIfConditions[`q${targetIndex - 1}`].push('none')
        //     //         } else {
        //     //           console.log(
        //     //             'AA visibleIfConditions',
        //     //             visibleIfConditions
        //     //           )
        //     //           console.log('AA choiceIndex', choiceIndex)
        //     //           for (
        //     //             let i = currentIndex + 1;
        //     //             i <= currentIndex + Math.abs(questionsHasVisibleIf);
        //     //             i++
        //     //           ) {
        //     //             console.log(
        //     //               'questionsHasVisibleIf',
        //     //               questionsHasVisibleIf
        //     //             )
        //     //             console.log('currentIndex', currentIndex)
        //     //             // Initialize the condition array if not present
        //     //             visibleIfConditions[`q${i}`] =
        //     //               visibleIfConditions[`q${i}`] || []

        //     //             if (visibleIfConditions[`q${i}`].length > 0) {
        //     //               console.log(
        //     //                 'BB visibleIfConditions[`q${i}`]',
        //     //                 visibleIfConditions[`q${i}`]
        //     //               )
        //     //               // Append to existing conditions using 'anyof' syntax
        //     //               visibleIfConditions[`q${i}`].push(choiceIndex)
        //     //             } else {
        //     //               console.log(
        //     //                 'CC visibleIfConditions[`q${i}`]',
        //     //                 visibleIfConditions[`q${i}`]
        //     //               )
        //     //               // Set the initial condition
        //     //               visibleIfConditions[`q${i}`].push(choiceIndex)
        //     //               console.log(
        //     //                 'DD visibleIfConditions[`q${i}`]',
        //     //                 visibleIfConditions[`q${i}`]
        //     //               )
        //     //             }
        //     //           }
        //     //         }
        //     //         console.log('22 visibleIfConditions', visibleIfConditions)

        //     //         // Update the conditions to use 'anyof' syntax
        //     //         // Object.keys(visibleIfConditions).forEach((key) => {
        //     //         //   if (Array.isArray(visibleIfConditions[key])) {
        //     //         //     visibleIfConditions[
        //     //         //       key
        //     //         //     ] = `{${key}} anyof [${visibleIfConditions[key].join(
        //     //         //       ', '
        //     //         //     )}]`
        //     //         //   }
        //     //         // })
        //     //       }
        //     //     }
        //     //   })
        //     // }
        //   }
        // })

        // 跳題設定會添加到下一題的表
        // 1.檢查跳題設定 0=無跳題, 1=單選跳題, 2 多選跳題
        // 2.單選跳題 加到物件{ 第X題回答第X選項會去第X題  {q16} == '0' => q21
        // {
        //   type: 'skip',
        //   expression: "{q16} = '0'",
        //   gotoName: 'q21',
        // },
        // 3.複選跳題 "{question1} anyof ['Item 1', 'Item 2', 'Item 3']"
        // 若跳題題號 == 當前題號+1 則不須跳題 "ta": [25, 25, 25, 25, 25, 25, 25, 24]
        // "ta": [18, 21]
        // {
        //   "type": "skip",
        //   "expression": "{question1} anyof ['Item 1', 'Item 2', 'Item 3']",
        //   "gotoName": "question4"
        //  }
        // 4.none 跳題 & other 跳題
        // 就算跳題還是會看到題目有visible的問題
        // "visibleIf": "{question1} anyof ['Item 1', 'Item 2', 'Item 3']"
        // 若跳題題號 == 當前題號+1 則沒事
        // 若不 == 當前題號+1 就要隱藏中間的題目 "ta": [18, 21] 隱藏18 19 20 21-17 = 4再減一

        receivedSurvey.data.forEach((data, i, arr) => {
          // [FIX] 記錄 none 和 other 的 index，供 useLoadProgress 使用
          if (choiceIndexMapRef) {
            const qName = 'q' + i
            if (!choiceIndexMapRef.current[qName]) {
              choiceIndexMapRef.current[qName] = {}
            }

            // 檢查 none (group)
            const groupIndex = data.cf?.parameters?.group?.[0]
            if (typeof groupIndex === 'number') {
              choiceIndexMapRef.current[qName].none = groupIndex
            }

            // 檢查 other
            if (data.op && Array.isArray(data.op)) {
              data.op.forEach((op, idx) => {
                if (op.o_type === 6) {
                  choiceIndexMapRef.current[qName].other = idx
                }
              })
            }
          }

          let newQuestion
          let imageQuestion = null

          // 有圖片
          if (data.ma.timer > 0) {
            setImagesReadingTime(data.ma.timer)
          }

          if (data.ma.image) {
            imageQuestion = {
              type: 'html',
              name: 'image' + i,
              html: `<div class="singleImgWrap"><img src="${data.ma.image}" alt='image'></div>`,
              visibleIf: visibleIfConditions[`q${i}`]
                ? visibleIfConditions[`q${i}`]
                : '',
              imagesReadingTime: getImageReadingTime(data, imagesReadingTime),
            }
          }

          // 多圖
          if (data.ma.images.length > 0) {
            newQuestion = {
              type: 'html',
              name: 'images' + i,
              html: multipleImages(data),
              visibleIf: visibleIfConditions[`q${i}`]
                ? visibleIfConditions[`q${i}`]
                : '',
              // 圖片閱讀時間
              imagesReadingTime: getImageReadingTime(data, imagesReadingTime),
            }
            if (data.cf.parameters.page === 1) {
              tempSurvey.pages.push({
                name: `page${pageOrderRef.current}`,
                elements: [newQuestion],
              })
              pageOrderRef.current = pageOrderRef.current + 1
            } else {
              // 否則，在當前頁面加入這個問題
              const currentPage = tempSurvey.pages[tempSurvey.pages.length - 1]
              currentPage.elements.push(newQuestion)
            }
          }

          // 影片
          if (data.ma.video) {
            function getYoutubeVideoId(url) {
              const regex =
                /(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([^&\?\/]+)/
              const match = url.match(regex)
              return match ? match[1] : null
            }

            function isMomento360Url(url) {
              return (
                url.startsWith('https://www.momento360.com/') ||
                url.startsWith('https://momento360.com/')
              )
            }

            const embedId = getYoutubeVideoId(data.ma.video)
            const isMomento360 = isMomento360Url(data.ma.video)

            newQuestion = {
              type: 'html',
              name: 'video' + i,
              html: isMomento360
                ? `
                <div class="imgWrap50">
                <h2 class="thirtySecondDelete" style="text-align: center">請完整觀看內容，稍後即可繼續作答</h2>
                <div class="video-responsive">
                <iframe
                  width="853"
                  height="480"
                  src="${data.ma.video}"
                  frameBorder="0"
                  allowFullScreen
                  title="Embedded Momento360"
                /></div></div>`
                : `
                <div class="imgWrap50">
                <h2 class="thirtySecondDelete" style="text-align: center">請完整觀看內容，稍後即可繼續作答</h2>
                <div class="video-responsive">
                <iframe
                  width="853"
                  height="480"
                  src="https://www.youtube.com/embed/${embedId}"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                  referrerPolicy="strict-origin-when-cross-origin"
                /></div></div>`,
              visibleIf: visibleIfConditions[`q${i}`]
                ? visibleIfConditions[`q${i}`]
                : '',
              imagesReadingTime: getImageReadingTime(data, imagesReadingTime),
            }
            if (data.cf.parameters.page === 1) {
              tempSurvey.pages.push({
                name: `page${pageOrderRef.current}`,
                elements: [newQuestion],
              })

              pageOrderRef.current = pageOrderRef.current + 1
              // console.log('pageOrder', pageOrderRef.current)
            } else {
              // 否則，在當前頁面加入這個問題
              const currentPage = tempSurvey.pages[tempSurvey.pages.length - 1]
              currentPage.elements.push(newQuestion)
            }
          }

          // 題型
          let type = ''
          switch (data.cf.q_type) {
            case 1:
              type = data.op[0]?.o_type === 1 ? 'imagepicker' : 'radiogroup'
              break
            case 2:
              switch (data.op[0]?.o_type) {
                case 0:
                  type = 'checkbox'
                  break
                case 1:
                  type = 'imagepicker'
                  break

                default:
                  type = 'checkbox'
                  break
              }
              break
            case 3:
              type = 'dropdown'
              break
            case 4:
              switch (data.op[0]?.o_type) {
                case 0:
                  type = 'comment'
                  break
                case 1:
                  type = 'text'
                  break
                case 2:
                  type = 'file'
                  break
                case 3:
                  type = 'file'
                  break

                default:
                  type = 'text'
                  break
              }
              break
            case 5:
              type = 'nouislider'
              break
            case 6:
              switch (data.cf.parameters.row_type) {
                case 0:
                  type = 'matrix'
                  break
                case 1:
                  type = 'matrix'
                  break

                default:
                  type = 'matrix'
                  break
              }
              break
            case 7:
              type = 'ranking'
              break
            case 8:
              type = 'nouislider'
              break
            case 9:
              type = 'dropdown'
              break
            case 10:
              type = 'signaturepad'
              break
            default:
              type = ''
              break
          }
          // 標題&副標
          const firstBreakIndex = data.ma.content.indexOf('\n\n')
          const splittedContent = data.ma.content.split('\n\n')
          newQuestion = {
            type: type,
            name: 'q' + i,
            title: splittedContent[0],
            description:
              splittedContent.length > 1
                ? data.ma.content.slice(firstBreakIndex + 2)
                : '',
            // TODO: 必填 true
            isRequired: DISABLE_REQUIRED
              ? false
              : notRequired === null
              ? true
              : checkNotRequired(i),
            // TODO: true
            isAllRowRequired: DISABLE_REQUIRED
              ? false
              : notRequired === null
              ? true
              : checkNotRequired(i),
            hideNumber: true,
            // requiredErrorText: '此題必填',
            choices:
              data.cf.q_type === 3
                ? convertDropdownChoices(data)
                : convertChoices(data),
            colCount: data.cf.parameters.layout === 1 ? 2 : 1,
            // 選項有圖片 data.op[0]?.o_type
            imageFit: data.op[0]?.o_type === 1 ? 'contain' : '',
            minImageWidth: data.op[0]?.o_type === 1 ? 200 : '',
            maxImageWidth: data.op[0]?.o_type === 1 ? 500 : '',
            showLabel: data.op[0]?.o_type === 1 ? true : false,
            multiSelect:
              data.op[0]?.o_type === 1
                ? data.cf.q_type === 1
                  ? false
                  : true
                : false,
            // 文字字數上限
            maxLength: data.op[0]?.o_type === 0 ? data.op[0].limit?.max : 1000,
            // 數字上下限
            inputType: data.op[0]?.o_type === 1 ? 'number' : '',
            min: data.op[0]?.o_type === 1 ? data.op[0].limit?.min : 0,
            max: data.op[0]?.o_type === 1 ? data.op[0].limit?.max : 2000,
            showNoneItem: checkShowNoneItem(data),
            noneText: checkNoneText(data),
            maxSelectedChoices: data.cf.parameters.limit
              ? data.cf.parameters.limit.max
              : data.cf.q_type === 7
              ? data.cf.parameters.sortable
              : 100,
            minSelectedChoices:
              data.cf.parameters.limit?.min > 1
                ? data.cf.parameters.limit.min
                : data.cf.q_type === 7
                ? data.cf.parameters.sortable
                : 0,
            // choicesOrder:
            //   data.cf.parameters.random.is_rand === 1 ? 'random' : 'none',
            separateSpecialChoices: true,
            showOtherItem: checkShowOtherItem(data),
            otherText: checkOtherText(data),
            placeholder: checkPlaceholder(data),
            // 矩陣
            requiredInAllRowsError: '請回答所有問題',
            alternateRows: true,
            columns: data.cf.parameters.row_op
              ? convertMatrixColumns(data)
              : '',
            rows: data.cf.parameters.row_op
              ? convertMatrixRows(data, i, visibleIfConditionsInit)
              : '',
            minErrorText: '數字不得小於 {0}',
            maxErrorText: '數字不得大於 {0}',
            minSelectErrorText: '至少選擇 {0} 個選項',
            minSelectedChoicesText: '至少選擇 {0} 個選項',
            rowTitleWidth: !data.cf.parameters.row_op
              ? ''
              : isMobile
              ? '100%'
              : '50%',
            columnMinWidth: data.cf.parameters.row_op ? '50px' : '',
            // 尺規題
            // autoGenerate: data.cf.q_type === 5 ? false : '',
            // rateCount: data.cf.q_type === 5 ? data.op[0].max : '',
            // rateMax: data.cf.q_type === 5 ? data.op[0].max : '',
            // rateValues: data.cf.q_type === 5 ? convertRateValues() : '',
            // displayMode: data.cf.q_type === 5 ? 'buttons' : '',
            step: data.cf.q_type === 5 ? data.op[0]?.interval : 1,
            rangeMin: data.cf.q_type === 5 ? data.op[0]?.min : 1,
            rangeMax: data.cf.q_type === 5 ? data.op[0]?.max : 7,
            pipsMode: data.cf.q_type === 5 ? 'steps' : 'steps',
            // 上傳圖片
            ...(data.cf.q_type === 4 && data.op[0]?.o_type === 2
              ? {
                  storeDataAsText: true,
                  waitForUpload: true,
                  acceptedTypes: 'image/jpeg,image/png',
                  chooseButtonCaption: '選擇 JPG 或 PNG 圖片',
                  filePlaceholder:
                    data.op[0]?.na || '請選擇 JPG 或 PNG 圖片上傳',
                }
              : {}),
            // 上傳 PDF
            ...(data.cf.q_type === 4 && data.op[0]?.o_type === 3
              ? {
                  storeDataAsText: true,
                  waitForUpload: true,
                  acceptedTypes: 'application/pdf',
                  chooseButtonCaption: '選擇 PDF 檔案（上限 20 MB）',
                  filePlaceholder:
                    data.op[0]?.na || '請選擇 PDF 檔案上傳（單檔上限 20 MB）',
                }
              : {}),
            // 簽名題
            ...(data.cf.q_type === 10
              ? {
                  penColor: '#000000',
                  signatureWidth: 800,
                  signatureHeight: 400,
                  ...(data.op?.[0]?.na ? { placeholder: data.op[0].na } : {}),
                }
              : {}),
            selectToRankEnabled: true,
            selectToRankAreasLayout: isMobile ? 'vertical' : '',
            selectToRankEmptyRankedAreaText: '所有選項已排序完成',
            selectToRankEmptyUnrankedAreaText: '拖放選項到此進行排序',
          }

          // 統一處理分頁邏輯
          if (data.cf.parameters.page === 1 && !DISABLE_PAGE_BREAK) {
            // 如果需要新分頁，將圖片和題目放在同一頁
            const pageElements = []
            if (imageQuestion) {
              pageElements.push(imageQuestion)
            }
            if (newQuestion) {
              pageElements.push(newQuestion)
            }

            tempSurvey.pages.push({
              name: `page${pageOrderRef.current}`,
              elements: pageElements,
            })

            pageOrderRef.current = pageOrderRef.current + 1
          } else {
            // 否則，在當前頁面加入這些問題
            const currentPage = tempSurvey.pages[tempSurvey.pages.length - 1]
            if (imageQuestion) {
              currentPage.elements.push(imageQuestion)
            }
            if (newQuestion) {
              currentPage.elements.push(newQuestion)
            }
          }

          // 如果data.ru.route.ta存在，将条件存储到visibleIfConditions
          // 如果存在当前问题的 visibleIf 条件，将它添加到 newQuestion.visibleIf 中
          if (visibleIfConditions[`q${i}`]) {
            newQuestion.visibleIf = visibleIfConditions[`q${i}`]
          }

          // 選項帶入(目前沒辦法帶none/other)
          // if (
          //   choicesFromQuestions[`q${i}`] &&
          //   data.ru?.op_bring?.b_type === 2
          // ) {
          //   newQuestion.choicesFromQuestion = choicesFromQuestions[`q${i}`]
          //   console.log('choicesFromQuestions', choicesFromQuestions)
          //   // if (arr[i - 1]) {

          //   // }
          //   // console.log('tempSurvey', tempSurvey)
          // }
          if (triggersConditionsInit !== null) {
            tempSurvey.triggers = triggersConditionsInit
          } else if (
            data.ru?.route?.ty &&
            data.ru?.route?.ta &&
            data.ru.route.ta.filter((v) => v === 999).length > 0
          ) {
            const question = 'q' + i
            data.ru.route.ta.filter((v) => v === 999)
            const answerWillCompleteSurvey = data.ru.route.ta.findIndex(
              (element) => element === 999
            )
            tempSurvey.triggers.push({
              type: 'complete',
              expression: `{${question}} = ${answerWillCompleteSurvey}`,
            })
          }

          // 頁數
          // if (newQuestion) {
          //   if (data.cf.parameters.page === 1) {
          //     tempSurvey.pages.push({
          //       name: `page${pageOrderRef.current}`,
          //       elements: [newQuestion],
          //     })

          //     pageOrderRef.current = pageOrderRef.current + 1
          //     // console.log('pageOrder', pageOrderRef.current)
          //   } else {
          //     // 否則，在當前頁面加入這個問題
          //     const currentPage = tempSurvey.pages[tempSurvey.pages.length - 1]
          //     currentPage.elements.push(newQuestion)
          //   }
          // }
        })
        setNewSurvey(tempSurvey)
        // console.log('tempSurvey666', tempSurvey)
      }
    }
    convertedToNewSurvey(receivedSurvey)
  }, [receivedSurvey])

  useEffect(() => {
    if (newSurvey) {
      // TODO:
      console.log('newSurvey', newSurvey)
    }
  }, [newSurvey])

  return newSurvey
}
